module.exports = __webpack_public_path__ + "img/monitoring-bulldozer-red.ecb67b04.svg";